export default __webpack_public_path__ + "static/media/sandalias-mujer.2433d813.png";